/**
 * returns a redux-like store object
 * @param  {Function} reducer - state reducer function
 * @return {Object}
 */
export function createStore( reducer, state = {} ) {

  const listeners = [];

  function dispatch( action ) {
    state = reducer( state, action );
    listeners.forEach( listener => listener( state ) );
  }

  function subscribe( listener ) {
    listeners.push( listener );
    return function unsubscribe() {
      const index = listeners.indexOf( listener );
      listeners.splice( index, 1 );
    };
  }

  function getState() {
    return state;
  }

  return { dispatch, subscribe, getState };
}

/**
 * combines a series of state reducers together into a single reducer, the key
 * of the reducers in the `reducers` param should map to their corresponding
 * property name in the state object itself
 *
 * @param  {Object} reducers
 * @return {Function}
 */
export function combineReducers( reducers ) {
  return function( state = {}, action ) {
    Object.keys( reducers ).forEach( key => {
      const prev = state[ key ];
      state[ key ] = reducers[ key ]( prev, action );
    });
    return state;
  };
}
